<template>
<div v-show="waypoints.length > 0 || showWhenEmpty">
  <div class="card-body">
    <h5 class="card-title">{{ title }} <small class="text-muted" v-show="subTitle">{{ subTitle }}</small></h5>
    <div>
      <ol>
        <li v-for="wp in waypoints" :key="wp.id" class="mt-1">
          <small class="d-none">{{ wp.sequence }}</small>

          <span class="badge bg-danger me-1" v-show="wp.serviceOrderPriority === 1">1</span>
          <span class="badge bg-warning me-1" v-show="wp.serviceOrderPriority === 2">2</span>
          <span class="badge bg-info me-1" v-show="wp.serviceOrderPriority === 3">3</span>

          <a v-if="wp.serviceOrderID !== $EMPTY_GUID" @click="$window.open($router.resolve({ name: 'ServiceOrder', params: { workOrderId: wp.serviceOrderID } }).href)" class="me-1" role="button">{{ wp.name }}</a>
          <span v-else class="me-1">{{ wp.name }}</span>

          <span v-show="wp.serviceOrderIsSpecial" class="badge bg-warning text-dark">Posebnost</span>
        </li>
      </ol>
    </div>
    <p v-show="waypoints.length === 0">{{ emptyMessage }}</p>
  </div>
</div>
</template>

<script setup>
import dayjs from "dayjs"
import { ref, computed, watch, onMounted } from "vue"
import { useAuth } from "../composition-api/useAuth"
import { useWorker } from "../composition-api/useWorker"
import { listEntitiesAsync } from "../api"

defineOptions({ name: "WaypointsCard" })

const props = defineProps({
    showWhenEmpty: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    day: {
      type: String,
    },
  })

const { fetchAuthAsync } = useAuth()
const { worker } = useWorker()

const waypoints = ref([])

const date = computed(() => props.day || dayjs().format("YYYY-MM-DD"))

const dayLabel = computed(() => {
  if (!props.day) return "danes"
  const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD")
  if (props.day === tomorrow) return "jutri"
  return dayjs(props.day).format("D.M.")
})

const emptyMessage = computed(() => `Ni poti za ${dayLabel.value}.`)

const loadWaypointsAsync = async () => {
  const workerId = worker.id.value
  if (!workerId) {
    waypoints.value = []
    return
  }
  waypoints.value = await listEntitiesAsync(fetchAuthAsync, `Waypoints/${workerId}/${date.value}`)
}

watch(
  () => worker.id.value,
  async (newVal) => {
    if (newVal) {
      await loadWaypointsAsync()
    } else {
      waypoints.value = []
    }
  },
)

onMounted(async () => {
  if (worker.id.value) {
    await loadWaypointsAsync()
  }
})
</script>
